import Dialog from '@pelckmans/elementis/components/dialog';
import TrashIcon from '@pelckmans/elementis/icons/trash';
import Button from '@pelckmans/elementis/components/button';
import { useContext } from 'react';
import ModalContext from '../../../../../contexts/ModalContext';
import RemoveGroupConfirmationModal from '../../remove-group-confirmation/RemoveGroupConfirmationModal';
import { deleteGroup } from '../../../api/MyGroupsApi';
import { useTranslation } from 'react-i18next';
import { SchoolYear } from '../../../context/MyGroupsContext';
import { Group } from '../../../../../api/groups';
import { useDefaultToast } from '../../../../../hooks/useDefaultToast';

const REMOVE_GROUP_CONFIRMATION_MODAL_ID = 'remove-group-confirmation-modal';

type Props = {
  group: Group;
  schoolYear: SchoolYear;
  editable: boolean;
  onGroupDelete: (deletedGroup: Group) => void;
  onClose: () => void;
  formId: string;
};

function InfoFooter({ group, schoolYear, editable, onGroupDelete, onClose, formId }: Props) {
  const { closeModal, showModal } = useContext(ModalContext);
  const { t } = useTranslation();
  const { successToast, failedToast } = useDefaultToast();

  const openConfirmationModal = () => {
    showModal(
      <RemoveGroupConfirmationModal
        id={REMOVE_GROUP_CONFIRMATION_MODAL_ID}
        group={group}
        schoolYear={schoolYear}
        onConfirm={handleDelete}
      />,
    );
  };

  const handleDelete = async () => {
    try {
      await deleteGroup(schoolYear, group.id);

      onGroupDelete(group);

      successToast();

      closeModal(REMOVE_GROUP_CONFIRMATION_MODAL_ID);

      onClose();
    } catch (err) {
      failedToast();
    }
  };

  return (
    <Dialog.Footer
      buttonGroupPropsLeft={{
        'aria-label': undefined,
        role: 'group',
        children: (
          <Button prominence="danger" startIcon={<TrashIcon />} onClick={openConfirmationModal}>
            {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.DELETE')}
          </Button>
        ),
      }}
      buttonGroupPropsRight={{
        'aria-label': undefined,
        role: 'group',
        children: editable ? (
          [
            <Button prominence="neutral" onClick={onClose} key="cancel">
              {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.CANCEL')}
            </Button>,
            <Button prominence="success" type="submit" form={formId} key="submit">
              {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.SUBMIT')}
            </Button>,
          ]
        ) : (
          <Button prominence="neutral" onClick={onClose}>
            {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.CLOSE')}
          </Button>
        ),
      }}
    />
  );
}

export default InfoFooter;
